import { Routes } from '@angular/router';
import { BlankLayoutComponent } from './modules/layout/blank-layout/blank-layout.component';
import { MainLayoutComponent } from './modules/layout/main-layout/main-layout.component';
import { DashboardComponent } from './modules/feature/dashboard/dashboard.component';
import { LoginComponent } from './modules/auth/login/login.component';
import { InsightsComponent } from './modules/feature/insights/insights.component';
import { ProfileComponent } from './modules/feature/profile/profile.component';
import { AddNewCardComponent } from './modules/feature/campaigns/add-new-card/add-new-card.component';

export const routes: Routes = [
    {
        path: 'login',
        component: LoginComponent
    },
    {
        path: '',
        component: MainLayoutComponent,
        children: [
            { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
            {
                path: 'dashboard',
                component: DashboardComponent
            },
            {
                path: 'campaigns',
                loadChildren: () =>
                    import('../app/modules/feature/campaigns/campaigns-routing.module').then(m => m.CampaignsModuleRoutingModule),
            },
            {
                path: 'insights',
                component: InsightsComponent
            },
            {
                path: 'profile',
                component: ProfileComponent
            }

        ],
    },
    {
        path: '',
        component: BlankLayoutComponent,
        children: [
            // { path: '', redirectTo: 'create-campaign', pathMatch: 'full' },
            {
                path: 'create-campaign',
                loadChildren: () =>
                    import('../app/modules/feature/create-campaign/create-campaign-routing.module').then(m => m.CreateCampaignModuleRoutingModule),
            },
            {
                path: "add-new-card",
                component: AddNewCardComponent
            }
        ],
    },



];